import { render } from "./EditAmountForm.vue?vue&type=template&id=0683cad0"
import script from "./EditAmountForm.vue?vue&type=script&lang=js"
export * from "./EditAmountForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__